/**
 * 文件说明: 菜单模型
 * ----------------------------------------
 * 创建用户: leo
 * 创建日期 18/08/01
 */

import request from 'utils/request'

export default request
